import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import StockStatus from '@prisjakt/ui-stock-status';
import CountryFlag from '@prisjakt/ui-country-flag';
import PriceNotice from '@prisjakt/ui-price-notice';
import Tooltip from '@prisjakt/ui-tooltip-new';

import * as S from './styles';

const StockStatusColumn = ({
  status,
  statusText,
  toneDown,
  countryCode,
  isInternationalPrice,
  showTooltip,
  priceType,
}) => {
  const { t } = useContext(AppContext);
  const processedStatusText = statusText
    ? statusText.replace(/-/g, '\u2011') /* no-breaking hyphen in dates */
    : t('product', `stock-status.${status || 'unknown'}`);

  return (
    <>
      {priceType !== undefined && priceType !== 'normal' ? (
        <S.PriceNoticeWrapper hideText>
          <Tooltip
            placement="left"
            title={t('product', `price-notice.${priceType}`)}
          >
            <PriceNotice
              type={priceType}
              textAtBottom={false}
              centerAlign={false}
              toneDown
            />
          </Tooltip>
        </S.PriceNoticeWrapper>
      ) : null}
      {countryCode && (
        <CountryFlag show={isInternationalPrice} countryCode={countryCode} />
      )}
      <S.StockStatusWrapper toneDown={toneDown}>
        <StockStatus
          classicIcons
          status={status}
          textAtBottom={false}
          centerAlign={false}
          showText={false}
          toneDown={toneDown}
          tooltip={showTooltip ? processedStatusText : ''}
        />
      </S.StockStatusWrapper>
    </>
  );
};

const { string, bool } = PropTypes;

StockStatusColumn.propTypes = {
  status: string,
  statusText: string,
  toneDown: bool,
  countryCode: string,
  isInternationalPrice: bool,
  showTooltip: bool,
  priceType: string,
};

StockStatusColumn.defaultProps = {
  status: undefined,
  statusText: undefined,
  toneDown: false,
  countryCode: null,
  isInternationalPrice: false,
  showTooltip: true,
  priceType: undefined,
};

export default memo(StockStatusColumn);
